var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tarja-top",staticStyle:{"text-align":"right","padding-right":"80px"}},[_vm._v("Vitória da Conquista - BA, "+_vm._s(new Date().toLocaleDateString()))])
}
var staticRenderFns = []

export { render, staticRenderFns }